var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.onTextClick}},[(_vm.format === 'html')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.textLocal)}}):_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }